// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606220500/js/" + chunkId + "." + {"44":"cb10e9f8","225":"b33e1043","481":"efda4a5c","486":"ed900b4d","770":"b791298a"}[chunkId] + ".0.4888613493060978.chunk.js";
};